import { render, staticRenderFns } from "./comunitiDashboard.vue?vue&type=template&id=23ba7ee8"
import script from "./comunitiDashboard.vue?vue&type=script&lang=js"
export * from "./comunitiDashboard.vue?vue&type=script&lang=js"
import style0 from "./comunitiDashboard.vue?vue&type=style&index=0&id=23ba7ee8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports